module.exports = __webpack_public_path__ + "static/smoke-2-0c57a83f79bd9653dc3ee22dc47bf294.mp4";